export const HEADER = {
  UPDATE_HEADER: 'UPDATE_HEADER',
  TOGGLE_READ_LOADER: 'TOGGLE_READ_LOADER',
  TOGGLE_WRITE_LOADER: 'TOGGLE_WRITE_LOADER'
};
